import { render, staticRenderFns } from "./contentDistribution.vue?vue&type=template&id=24f760d1&scoped=true"
import script from "./contentDistribution.vue?vue&type=script&lang=js"
export * from "./contentDistribution.vue?vue&type=script&lang=js"
import style0 from "./contentDistribution.vue?vue&type=style&index=0&id=24f760d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f760d1",
  null
  
)

export default component.exports